import { useContext, useEffect, useState } from 'react';
import DashboardContext from 'Context';
import CustomPagination from 'components/table/pagination';
import { Button, Col, Descriptions, Modal, Row, Space, Table } from 'antd';
import axios from 'axios';
import InputControl from 'components/inputs/InputControl';
import Excel from 'components/table/excel';
import Countdown from 'react-countdown';

export default function JobDispatchWorker({ matchId = null }) {
  const { urldashboard, authentication, idview } = useContext(DashboardContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [headers, setHeaders] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [formData, setFormData] = useState({});
  const [record, setRecord] = useState({});
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  const [moreInfoModal, setMoreInfoModal] = useState(false);

  useEffect(() => {
    getJobDispatch({
      page: pagination?.page,
      pageSize: pagination?.pageSize,
    });
  }, []);

  const getJobDispatch = async ({ page, pageSize }) => {
    setLoading(true);
    try {
      let url = '/jobDispatch/jobDispatchesForWorker';
      const res = await axios.get(urldashboard + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
        params: {
          page,
          pageSize,
          workerId: matchId || JSON.parse(sessionStorage.getItem('workerId')) || idview,
          ...formData,
        },
      });
      const data = await res.data;
      setHeaders(data?.headers?.map((item) => item.label));
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getJobDispatch({
      page: newPage,
      pageSize: newPageSize,
    });
  };

  const search = () => {
    getJobDispatch({
      page: 1,
      pageSize: 10,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'نام مشتری',
      dataIndex: 'customerName',
      key: 'customerName',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'آدرس مشتری',
      dataIndex: 'customerAddress',
      key: 'customerAddress',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'تاریخ سفارش',
      dataIndex: 'persainOrderDate',
      key: 'persainOrderDate',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'وضعیت',
      dataIndex: 'jobDispatchStatus',
      key: 'jobDispatchStatus',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'زمان باقی مانده برای پاسخ',
      dataIndex: 'responseDeadLine',
      key: 'responseDeadLine',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value, record) => (
        <span>
          {record?.status === 0 ? <Countdown date={value + 10000} /> : 0}
        </span>
      ),
    },
    {
      title: 'زمان آخرین اقدام',
      dataIndex: 'زمان آخرین اقدام',
      key: 'persianActionTime',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'زمان پخش کار',
      dataIndex: 'persainBroadCastDate',
      key: 'persainBroadCastDate',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'فرصت داده شده',
      dataIndex: 'deadlineHour',
      key: 'deadlineHour',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'اقدام به موقع',
      dataIndex: 'isTimelyAction',
      key: 'isTimelyAction',
      responsive: ['xl', 'lg'],
      render: (value) => (
        <span>
          {value ? (
            <i
              className='mdi mdi-check'
              style={{ color: 'green', fontSize: '1.5rem' }}
            ></i>
          ) : (
            <i
              className='mdi mdi-close'
              style={{ color: 'red', fontSize: '1.5rem' }}
            ></i>
          )}
        </span>
      ),
    },
    {
      title: 'دلیل رد کار',
      dataIndex: 'rejectReason',
      key: 'rejectReason',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'اطلاعات بیشتر',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => showInfoModal(record)}>
          <i className='mdi mdi-eye'></i>
        </Button>
      ),
    },
  ];

  const showInfoModal = async (data) => {
    setRecord(data);
    setMoreInfoModal(true);
  };

  return (
    <>
      <Row
        gutter={20}
        style={{
          marginTop: 25,
          alignItems: 'center',
        }}
      >
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          style={{ marginBottom: 20, display: 'flex', alignItems: 'center' }}
        >
          <InputControl
            width={'100%'}
            url='/common/jobDispatchType'
            label='وضعیت پخش کار'
            name='jobDispatchType'
            handelValue={(_, value) =>
              setFormData({ ...formData, jobDispatchType: value })
            }
          />
          <Button
            onClick={() => search()}
            style={{
              height: '3rem',
              width: '10%',
              display: 'table-cell',
              padding: 0,
              marginTop: '6px',
            }}
          >
            <i className='mdi mdi-magnify'></i>
          </Button>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
          <Space
            wrap
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            <Excel data={data} headers={headers} fileName={`لیست_پخش_کار`} />
          </Space>
        </Col>
      </Row>

      <Table
        size='small'
        style={{ textAlign: 'right', marginTop: 10 }}
        rowClassName={() => 'center'}
        columns={columns}
        bordered={true}
        dataSource={data}
        loading={loading}
        pagination={false}
        locale={{
          emptyText: 'موردی یافت نشد',
        }}
      />

      {!loading && (
        <CustomPagination
          totalRecord={totalRecord}
          pagination={pagination}
          handlePagination={handlePagination}
          notMain
        />
      )}

      <Modal
        title='اطلاعات بیشتر'
        closable={false}
        open={moreInfoModal}
        onCancel={() => {
          setMoreInfoModal(false);
          setRecord({});
        }}
        footer={[
          <Button key='back' onClick={() => setMoreInfoModal(false)}>
            بستن
          </Button>,
        ]}
        bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
      >
        <Descriptions bordered column={1} size={'small'}>
          <Descriptions.Item label='نام مشتری'>
            {record?.customerName ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='آدرس مشتری'>
            {record?.customerAddress ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='تاریخ سفارش'>
            {record?.persainOrderDate
              ? record?.persainOrderDate
              : 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='وضعیت'>
            {record?.jobDispatchStatus ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='زمان باقی مانده برای پاسخ'>
            {record?.status === 0 ? (
              <Countdown date={record?.responseDeadLine + 10000} />
            ) : (
              0
            )}
          </Descriptions.Item>
          <Descriptions.Item label='زمان آخرین اقدام'>
            {record?.persianActionTime
              ? record?.persianActionTime
              : 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='زمان پخش کار'>
            {record?.persainBroadCastDate
              ? record?.persainBroadCastDate
              : 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='فرصت داده شده'>
            {record?.deadlineHour ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='اقدام به موقع'>
            <span>
              {record?.isTimelyAction ? (
                <i
                  className='mdi mdi-check'
                  style={{ color: 'green', fontSize: '1.5rem' }}
                ></i>
              ) : (
                <i
                  className='mdi mdi-close'
                  style={{ color: 'red', fontSize: '1.5rem' }}
                ></i>
              )}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label='دلیل رد کار'>
            {record?.rejectReason ? record?.rejectReason : 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='توضیحات رد کار'>
            {record?.rejectReasonDescription ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
        </Descriptions>
      </Modal>
    </>
  );
}
